<template>
    <div class="tab-menu type02">
        <ul class="tab-menu__list">
            <li class="tab-menu__item"><button type="button" class="tab-menu__btn">관심 의료진</button></li>
            <li class="tab-menu__item"><button type="button" class="tab-menu__btn">관심 콘텐츠</button></li>
        </ul>
    </div>

    <div class="board-list">
        <div class="board__search type2">
            <div class="board__select" :class="{ 'active': selectOn }" @click="selectFn">
                <select name="" id="">
                    <option value="전체">전체</option>
                    <option value="제목">제목</option>
                    <option value="글">관심설정</option>
                </select>
            </div>
        </div>

        <div class=" board-list__table">
            <table>
                <colgroup>
                    <col style="width: 25%;">
                    <col style="width: auto">
                    <col style="width: 18%;">
                </colgroup>
                <thead>
                    <tr>
                        <th>구분</th>
                        <th>제목</th>
                        <th>관심설정</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="number"><span class="num">14250</span><span class="new"></span></td>
                        <td class="left tit">
                            <a href="javascript:;" class="board-list__link">
                                <span class="new"></span>
                                <p>[5월 진료안내] 근로자의날·어린이날대체휴일·부처님오신날 - 휴진</p>
                            </a>
                            <span class="hart on"><span class="icon"></span></span>
                        </td>
                        <td class="hart on"><span class="icon"></span></td>
                    </tr>
                    <tr>
                        <td class="number"><span class="num">14250</span><span class="new"></span></td>
                        <td class="left tit">
                            <a href="javascript:;" class="board-list__link">
                                <span class="new"></span>
                                <p>주님 부활 대축일 기념 작은음악회 개최, 아름다운 음악으로 환자들과 함께 부활의 기쁨 나눠 천주교 마산 주님 부활 대축일 기념 작은음악회 개최, 아름다운 음악으로 환자들과 함께 부활의 기쁨 나눠 천주교 마산</p>
                            </a>
                            <span class="hart on"><span class="icon"></span></span>
                        </td>
                        <td class="hart on"><span class="icon"></span></td>
                    </tr>
                    <tr>
                        <td class="number"><span class="num">14250</span><span class="new"></span></td>
                        <td class="left tit">
                            <a href="javascript:;" class="board-list__link">
                                <p>주님 부활 대축일 기념 작은음악회 개최, 아름다운 음악으로 환자들과 함께 부활의 기쁨 나눠 천주교 마산 주님 부활 대축일 기념 작은음악회 개최, 아름다운 음악으로 환자들과 함께 부활의 기쁨 나눠 천주교 마산</p>
                            </a>
                            <span class="hart on"><span class="icon"></span></span>
                        </td>
                        <td class="hart on"><span class="icon"></span></td>
                    </tr>
                </tbody>
            </table>

            <!-- 우리금융저축은행과 같은 페이징가져왔습니다. -->
            <div class="contents">
                <div class=" paging">
                    <a href="javascript:;" class="board__pagination-btn first">처음</a>
                    <a href="javascript:;" class="board__pagination-btn prev">이전</a>
                    <a href="javascript:;" class="board__pagination-btn num active"><span>90</span></a>
                    <a href="javascript:;" class="board__pagination-btn num"><span>91</span></a>
                    <a href="javascript:;" class="board__pagination-btn num"><span>93</span></a>
                    <a href="javascript:;" class="board__pagination-btn num"><span>910</span></a>
                    <a href="javascript:;" class="board__pagination-btn next">다음</a>
                    <a href="javascript:;" class="board__pagination-btn last">마지막</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                selectOn: false,
            };
        },
        methods: {
            selectFn() {
                this.selectOn = !this.selectOn;
            },
            outsideClick(event) {
                if (!event.target.closest('.board__select')) {
                    this.selectOn = false;
                }
            },
        },
        mounted() {
            document.addEventListener('click', this.outsideClick);
        }
    };
</script>

<style>
    /* 스타일링을 원하는 경우 여기에 작성 */
</style>